import React, { Fragment } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import NucleusLogo from '../../../assets/Images/nUCLeus_logo.jpg';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  image_logo: {
    backgroundImage: `url(${NucleusLogo})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    // backgroundColor:
    //   theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    // backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100px',
    width: '230px'

  },
}));

export default function ChangePassword() {
  const classes = useStyles();
  const [showNP, setShowNP] = React.useState(false);
  const [showCP, setShowCP] = React.useState(false);

  const handleClickShowNPassword = () => {
    const update = !showNP;
    setShowNP(update);
  };

  const handleClickShowCPassword = () => {
    const update = !showCP;
    setShowCP(update);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Fragment>
      <div style={{ height: '50px' }} />
      <Grid item className={classes.image_logo} />
      <div style={{ height: '50px' }}>
        <Typography variant="h4" style={{ textAlign: 'left' }} component="h2" gutterBottom>
          Change Password
                </Typography>
      </div>
      <form onSubmit="" className={classes.form}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="newPassword"
          label="New Password"
          name="newPassword"
          type={showNP ? "text" : "password"}
          autoFocus
          InputProps={{
            endAdornment:
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowNPassword}
                  onMouseDown={handleMouseDownPassword}
                  size="large">
                  {showNP ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>

          }}
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="confirmPassword"
          label="Confirm Password"
          type={showCP ? "text" : "password"}
          id="confirmPassword"
          InputProps={{
            endAdornment:
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowCPassword}
                  onMouseDown={handleMouseDownPassword}
                  size="large">
                  {showCP ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>

          }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          Submit
            </Button>
        <Grid container justifyContent="center">
          <Grid item>
            <Link to="/login" variant="body2">
              {"Return to Login."}
            </Link>
          </Grid>
        </Grid>
      </form>
    </Fragment>
  );
}